



export class McCardSubtle extends HTMLElement {

  constructor() {
    super()
    this.attachShadow({ mode: "open" })
    const temmplate = document.createElement("template")
    temmplate.innerHTML = `
<style>
  :host {
    display: block;
    border-radius: 10px;
    background-color: hsl(var(--mc-muted)/.1);
    padding: .5rem;
  }
</style>
<slot></slot>
`
    this.shadowRoot.append(temmplate.content.cloneNode(true))
  }
}


if (!window.customElements.get("mc-card-subtle")) {
  window.customElements.define("mc-card-subtle", McCardSubtle)
}
